import { BaseService } from './base-service';

export class SystemService extends BaseService {
  baseURL = 'System';

  getAllRoles = () => {
    return this.get('/roles');
  }
}
